import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconSortDescending = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.6936 19.4338C11.7871 19.4756 11.8909 19.4989 12 19.4989C12.1048 19.4989 12.2045 19.4775 12.2951 19.4387C12.3802 19.4024 12.4599 19.3497 12.5295 19.2805L12.5311 19.2789L17.78 14.03C18.0733 13.7367 18.0733 13.2611 17.78 12.9678C17.4867 12.6745 17.0111 12.6745 16.7178 12.9678L12.7511 16.9345V5.00111C12.7511 4.58628 12.4148 4.25 12 4.25C11.5852 4.25 11.2489 4.58628 11.2489 5.00111V16.9345L7.28222 12.9678C6.98889 12.6745 6.51332 12.6745 6.21999 12.9678C5.92667 13.2611 5.92667 13.7367 6.22 14.03L11.4689 19.2789C11.4801 19.2901 11.4916 19.3009 11.5033 19.3112L11.6936 19.4338Z",
		fill: "currentColor"
	})
});
export { SvgIconSortDescending as ReactComponent };
